import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100vh',
  },
  summaryTitle: {
    color: '#c5c5c5',
  },
  row: {
    padding: theme.spacing(2),
  },
  rowExportExcel: {
    padding: theme.spacing(2),
    textAlign: 'right',
  },
}))
